var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvfFlowSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_907_1008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2207 1.96539V1.96535C4.22068 1.5256 4.57691 1.16931 5.01678 1.16931H13.9689L20.103 7.30349V22.8732C20.103 23.3128 19.7463 23.6693 19.307 23.6693H5.01678C4.57698 23.6693 4.2207 23.313 4.2207 22.8732V1.96539Z",
    stroke: "#D3B474",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7444 7.75198H14.717C13.8629 7.75198 13.1709 7.05992 13.1709 6.2059V1.17847L19.7444 7.75198Z",
    fill: "#D3B474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9641 10.8699H8.35911C7.81012 10.8699 7.36523 11.3149 7.36523 11.8637V18.481C7.36523 19.0298 7.81009 19.4749 8.35911 19.4749H15.9641C16.513 19.4749 16.9579 19.0299 16.9579 18.481V11.8637C16.9579 11.3149 16.5131 10.8699 15.9641 10.8699ZM9.35298 15.045H11.1677V15.3H9.35298V15.045ZM13.1554 15.045H14.9702V15.3H13.1554V15.045ZM14.9702 13.0573H13.1555V12.8576H14.9702V13.0573ZM11.1677 12.8576V13.0572H9.35298V12.8576H11.1677ZM9.35298 17.2877H11.1677V17.4873H9.35298V17.2877ZM13.1554 17.4873V17.2876H14.9702V17.4873H13.1554Z",
    stroke: "#D3B474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_907_1008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.161621 0.419312)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvfFlowSheet);
export default __webpack_public_path__ + "static/media/IVFFlowSheet.735cb2a8af121edb3a4d65863b01b084.svg";
export { ForwardRef as ReactComponent };